import { IModel, Model } from './Model';

export interface IFeatureFlagModel extends IModel {
  featureFlagId: number;
  name: string;
  description: string;
  globalStartDate: string | undefined;
  globalEndDate: string | undefined;
  enabled: boolean;
}

export class FeatureFlagModel extends Model implements IFeatureFlagModel {
  featureFlagId: number;
  name: string;
  description: string;
  globalStartDate: string | undefined;
  globalEndDate: string | undefined;
  enabled: boolean;

  constructor(params: Partial<IFeatureFlagModel>) {
    super(params);
    const {
      featureFlagId = 0,
      name = '',
      description = '',
      globalStartDate = undefined,
      globalEndDate = undefined,
      enabled = false,
    } = params;

    this.featureFlagId = featureFlagId;
    this.name = name;
    this.description = description;
    this.globalStartDate = globalStartDate;
    this.globalEndDate = globalEndDate;
    this.enabled = enabled;
  }
}
